import { nodeTypeDict } from '@/services/nodeTypeService';
import axios from 'axios';

export default {
  state: {
    chains: [],
  },
  getters: {
    getChains(state) {
      return state.chains;
    },
    allChainIds(state) {
      const ids = [];
      state.chains.forEach((chain) => {
        ids.push(chain.id);
      });
      return ids;
    },
    allNodeIds(state) {
      const ids = [];
      state.chains.forEach((chain) => {
        chain.nodes.forEach((node) => {
          ids.push(node.id);
        });
      });
      return ids;
    },
    allNodes(state) {
      const ids = [];
      state.chains.forEach((chain) => {
        chain.nodes.forEach((node) => {
          ids.push(node);
        });
      });
      return ids;
    },
    getNextSortOrder: (state) => (chainId, type) => {
      const chain = state.chains.find((c) => c.id === chainId);
      if (!chain) return 0;

      let nodesOfType;
      if (
        type === nodeTypeDict['Block Producer'] ||
        type === nodeTypeDict['Nodeos Follower']
      ) {
        nodesOfType = chain.nodes.filter(
          (n) =>
            n.type === nodeTypeDict['Block Producer'] ||
            n.type === nodeTypeDict['Nodeos Follower']
        );
      } else {
        nodesOfType = chain.nodes.filter((n) => n.type === type);
      }

      if (nodesOfType.length === 0) return 0;

      const sortOrders = nodesOfType.map((n) => n.sort_order);
      for (let i = 0; i <= sortOrders.length; i++) {
        if (!sortOrders.includes(i)) return i;
      }
      return sortOrders.length;
    },
    checkValidSortOrder: (state) => (chainId, type, sortOrder) => {
      const chain = state.chains.find((c) => c.id === chainId);
      if (!chain) return true;

      let nodesOfType;
      if (
        type === nodeTypeDict['Block Producer'] ||
        type === nodeTypeDict['Nodeos Follower']
      ) {
        nodesOfType = chain.nodes.filter(
          (n) =>
            n.type === nodeTypeDict['Block Producer'] ||
            n.type === nodeTypeDict['Nodeos Follower']
        );
      } else {
        nodesOfType = chain.nodes.filter((n) => n.type === type);
      }

      return !nodesOfType.some((n) => n.sort_order === sortOrder);
    },
  },
  mutations: {
    initialiseChains(state, value) {
      state.chains = value;
    },
    UPDATE_BP_JSON_STATUS(state, { chain_id, status, lastUpdated }) {
      const chain = state.chains.find((c) => c.id === chain_id);
      if (chain) {
        chain.bpJsonStatus = status;
        chain.bpJsonLastUpdated = lastUpdated;
      }
    },
    SET_CHAINS(state, chains) {
      state.chains = chains;
    },
  },
  actions: {
    initialiseChains(context, chains) {
      console.log('initialiseChains: starting');
      // console.log('Received chains:', JSON.stringify(chains));
      context.commit('initialiseChains', chains);
      console.log('initialiseChains: finishing');
      return;
    },
    async fetchChains({ commit }) {
      const response = await axios.get('/api/v1/chains/');
      commit(
        'SET_CHAINS',
        response.data.map((chain) => ({
          // ... existing fields ...
          monitor_bp_json: chain.monitor_bp_json || false,
          bpJsonStatus: chain.bp_json_status || 'Unknown',
          bpJsonLastUpdated: chain.bp_json_last_updated || null,
        }))
      );
    },
  },
  modules: {},
};
